import { filter, map } from 'lodash';
import { hasConfig } from './support';


/**
 * Gets the string following the hash sign
 * in the current window location.
 *
 * @returns string
 */
export function get() {
  // We can't use window.location.hash here because it's not
  // consistent across browsers - Firefox will pre-decode it!
  const { href } = window.location;
  const index = href.indexOf('#');
  return index === -1 ? '' : href.slice(index + 1);
}

/**
 * Replaces the current hash location.
 *
 * @param path
 */
export function replace(path) {
  const i = window.location.href.indexOf('#');
  window.location.replace(`${window.location.href.slice(0, i >= 0 ? i : 0)}#${path}`);
}

/**
 * Makes sure that we got a valid path in the URL.
 * If we have no "path", we simply use a slash ('/').
 *
 * @returns boolean
 */
export function ensureSlash() {
  const path = get();
  if (path.charAt(0) === '/') {
    return true;
  }

  replace(`/${path}`);
  return false;
}

/**
 * Remaps the given stack and updates the hash in the URL.
 *
 * @param stack
 */
export function rehash(stack) {
  replace(`/${map(stack, ({ key, id }) => `${key}:${id}`).join('/')}`);
}

/**
 * Reinterprets the contents in the URL,
 * removes invalid entries and returns a valid key -> id mapping.
 *
 * @return {Array}
 */
export function revalidate() {
  ensureSlash();

  const segments = get().slice(1).split('/');
  const matches = map(segments, segment => /([\w-]+):([0-9]+)/i.exec(segment));
  const valid = filter(matches, match => match !== null && hasConfig(match[1]));
  const stack = map(valid, match => ({
    key: match[1],
    id: parseInt(match[2], 10),
  }));

  rehash(stack);
  return stack;
}



// WEBPACK FOOTER //
// ./resources/assets/js/view-stack/utils/hash.js